import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { z } from "zod";

export const GUIDE_ESCALATION_SERVER_NAME = "guide_escalation" as const;
export const ESCALATE_TO_HUMAN_TOOL_NAME = "escalate_to_human";

export const GUIDE_ESCALATION_TOOLS_METADATA = [
  {
    name: ESCALATE_TO_HUMAN_TOOL_NAME,
    description:
      "Bring in a person from the MemoAir team on this conversation, once the user has said yes to it. The team is alerted once per conversation and a team member replies here under their own name. Call it at most once per conversation and tell the user what it returns.",
    schema: {
      question: z
        .string()
        .min(1)
        .max(4000)
        .describe("The user's question, in their own words."),
      reason: z
        .string()
        .max(1000)
        .optional()
        .describe("Why you could not answer it, in one sentence."),
    },
    // The user agreed in the conversation before this is called, and it reaches only
    // MemoAir's own team, so a second confirmation would only add friction.
    stake: "never_ask",
    displayLabels: {
      running: "Alerting the MemoAir team",
      done: "Alerted the MemoAir team",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const GUIDE_ESCALATION_SERVER = {
  serverInfo: {
    name: GUIDE_ESCALATION_SERVER_NAME,
    version: "1.0.0",
    description:
      "Hand a conversation @Guide cannot answer to a person on the MemoAir team.",
    authorization: null,
    icon: "ActionMegaphoneIcon",
    documentationUrl: null,
  },
  tools: GUIDE_ESCALATION_TOOLS_METADATA,
} as const satisfies ServerMetadata;
